
<div class="actions-holder">
	<ng-content select="[left]"></ng-content>
</div>
<div class="actions-holder">
	<ng-content></ng-content>
</div>
